import { FILTER_TYPE } from '@intelligence/v3/filterControls/filterTypes';
import { GENRE_SOURCE_MAP } from '@intelligence/components/GenreSelect/constants';

import { PAGE_ID } from './constants';
import { getRobloxDeviceFilterItem } from './config/robloxDeviceFilter';

import type { IFilterItemConfig } from '@intelligence/v3/filterCore/types';
import type { IGenreSourcesGenreOptions } from '@intelligence/components/GenreSelect/types';

interface IGetRobloxGameRankFilterItemsParams {
  regionOptions: any[];
  genreOptions?: IGenreSourcesGenreOptions;
  genreOptionsLoading?: boolean;
}

export const getRobloxGameRankFilterItems = (
  params: IGetRobloxGameRankFilterItemsParams,
): IFilterItemConfig[] => {
  const { regionOptions, genreOptions = {}, genreOptionsLoading = false } = params;

  return [
    {
      type: FILTER_TYPE.RANGE_PICKER,
      field: 'date',
      controlProps: {
        showSelectType: false,
        typeList: ['date'],
        showShortcut: false,
        isSingleSelect: true,
        autoRange: { length: 0 },
      },
      inherit: ['all'],
    },
    {
      type: FILTER_TYPE.REGION_SELECT,
      field: 'region',
      controlProps: {
        options: regionOptions,
        singleSelect: true,
        title: 'dbi_region',
        placeholder: 'dbi_select_region',
        className: 'dbi-mobile-store-rank_composed-country-select',
        overlayClassName: 'dbi-alltopcharts-region-cascader-select-overlay',
      },
      inherit: ['all'],
    },
    getRobloxDeviceFilterItem(),
    {
      type: FILTER_TYPE.GENRE_SELECT,
      field: 'genre',
      hoverTipsKey: 'dbi_roblox_genrefilter_info',
      controlProps: {
        sources: [GENRE_SOURCE_MAP.ROBLOX],
        allowEmptySources: true,
        genresOptionsData: genreOptions,
        genresOptionsDataLoading: genreOptionsLoading,
      },
      inherit: [PAGE_ID],
    },
  ];
};
